<template>
  <div>
    <Breadcrumbs :items="breadcrumbs" />
    <p>
      Thank you for using RayPRO. Your license has expired but we hope you will continue using the system
      and we offer various options to make this possible. Please contact our sales team for further details.
    </p>
    <p>
      For sales and enquiries, please contact us at <a href="mailto:raypro@rayner.com">raypro@rayner.com</a>.
    </p>
    <p>
      If you wish to purchase a new license directly, please visit our <a href="https://rayner.rayproplus.com/" target="_blank">payment portal</a>.
    </p>
    <p>
      If you need technical support, please see our <a href="https://rayner.com/raypro/" target="_blank">support page</a>.
    </p>
    <p>
      For all other enquiries, please see our <a href="https://rayner.com/en/contact-us/" target="_blank">contact page</a>.
    </p>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  export default {
    name: 'LicenseExpired',
    components: {Breadcrumbs},
    data() {
      return {
        breadcrumbs: [{label: 'License Expired'}],
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/LicenseExpired.vue